import { TwoFactorSecretPayloadModel } from '@/models/auth/auth.model';
import { defineStore } from 'pinia';

type AuthState = {
  token: string;
  qr: string;
  link: string;
  secretKey: string;
  visibleTwoFactorDialog: boolean;
};

export const useAuth = defineStore({
  id: 'auth',
  state: (): AuthState => ({
    token: localStorage.getItem('token') || '',
    qr: '',
    link: '',
    secretKey: '',
    visibleTwoFactorDialog: false,
  }),
  actions: {
    setToken(token: string) {
      localStorage.setItem('token', token);
      this.token = token;
    },
    setTwoFactorSecretData(secretData: TwoFactorSecretPayloadModel) {
      this.secretKey = secretData.secretKey;
      this.qr = secretData.qr;
      this.link = secretData.link;
    },
    setVisibleTwoFactorDialog(dialogVisible: boolean) {
      this.visibleTwoFactorDialog = dialogVisible;
    },
  },
});
